import script from "./marketing-landing.vue?vue&type=script&setup=true&lang=js"
export * from "./marketing-landing.vue?vue&type=script&setup=true&lang=js"

import "./marketing-landing.vue?vue&type=style&index=0&id=71165114&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71165114"]])

export default __exports__